import elWidth from "./elWidth.js";

export default (el) => elWidth(el, "inner");
